import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const rebuildList = function (list: any, isChild?: any) {
  let result = [];

  if (list) {
    result = list.concat();
    result.forEach((item: any, index: any) => {
      item._showChildren = true;
      item.isChild = !!isChild;
      item.isFirst = index === 0;
      item.isLast = index === result.length - 1;

      if (item.children) {
        item.children = rebuildList(item.children, true);
      }
    });
  }

  return result;
};

const URL = {
  LIST: '/dh-datamaint/questionSubject/list',
  ADD: '/dh-datamaint/questionSubject/add',
  DELETE: '/dh-datamaint/questionSubject/delete',
  DETAIL: '/dh-datamaint/questionSubject/getById',
  UPDATE: '/dh-datamaint/questionSubject/update',
  UPDATE_BASE_INFO: '/dh-datamaint/questionSubject/updateBaseInfo',
  MOVE: '/dh-datamaint/questionSubject/move'
};

class SubjectModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getList(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.get(URL.LIST, { params: payload.data });
      return rebuildList(res.data.data);
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE, payload.data);
    },

    async UpdateBaseInfo(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE_BASE_INFO, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async Move(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.MOVE, payload.data);
    }
  };
}

export const subjectModule = new SubjectModule();
